import React, { useState } from 'react';
import { AppBar, Typography } from '@material-ui/core';
import UnreadMessageBadge from '../utilities/NavBar/UnreadMessageBadge';
import { ReactComponent as ChatIcon } from '../../resources/images/chat.svg';
import ChatPage from './ChatPage';
import { makeStyles } from '@material-ui/core/styles';
import { COLOR_WHITE } from '../utilities/Material';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
    chatBarClosedContainer: {
        top: 'auto',
        bottom: 0,
        width: '179.39px',
        height: '40px',
        right: '43px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    chatBarClosed: {
        backgroundColor: COLOR_WHITE,
        boxShadow: '0px 12.1212px 12.1212px rgba(17, 101, 142, 0.14)',
        borderRadius: '15px 15px 0px 0px',
    },
    chatIcon: {
        width: '16.97px',
        height: '16.97px',
        '& path': {
            stroke: theme.palette.primary.main,
        },
    },
    chatBarText: {
        height: '20.61px',
        width: '104.24px',
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: '13.85px',
        lineHeight: '150%',
        letterSpacing: '0.138528px',
        color: theme.palette.primary.dark,
        order: 1,
        flexGrow: 0,
        margin: '9.7px',
    },
}));

export const DesktopChatBar = () => {
    const classes = useStyles();

    const [chatBarOpen, setChatBarOpen] = useState(false);

    return chatBarOpen ? (
        <ChatPage desktopChat={true} setChatBarOpen={setChatBarOpen} />
    ) : (
        <AppBar className={clsx(classes.chatBarClosed, classes.chatBarClosedContainer)} position="fixed" onClick={() => setChatBarOpen(true)}>
            <UnreadMessageBadge
                children={
                    <div className={classes.chatBarClosedContainer}>
                        <ChatIcon title={'chat icon'} className={classes.chatIcon} />
                        <Typography align="center" className={classes.chatBarText} data-cy="chat-bar">
                            Watchman Chat
                        </Typography>
                    </div>
                }
            />
        </AppBar>
    );
};
